var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-row',[_c('kt-col',{attrs:{"xs":"12","md":"6"}},[(_vm.status !== 'loading')?_c('deposit-info',{attrs:{"deposit":_vm.form_data}}):_vm._e()],1),_c('kt-col',{attrs:{"xs":"12","md":"6"}},[_c('deposit-setting'),(_vm.status !== 'loading')?_c('deposit-limits-settings',{attrs:{"deposit":_vm.form_data}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }